import React from "react"
import { SelectSeeker } from "@ui-seeker/core"

import { transmission } from "@signals"


export default function AppCommonFiltersTransmissionSelect({ ...props }) {
	return <SelectSeeker
		label="Transmission"
		value={transmission.value}
		isClearable
		onChange={e => transmission.value = e.target.value}
		placeholder="Any transmission"
		options={[
			{ label: 'Option 1', value: 'EUR' },
			{ label: 'Option 2', value: 'GBP' }
		]}
		{...props}
	/>
}